import React from 'react'
import DiagnosticTable from './DiagnosticTable'
import LanguageStrings from '../../../../i18n/locales'

const DiagnosticTab = (): JSX.Element => {
  const DiagnosticInfoStrings = LanguageStrings().Diagnostics.Info
  return (
    <div style={{ width: 'calc(100vw - 3.5rem)', paddingRight: '3em' }}>
      <div className="configurations-table-heading">
        <h5>{DiagnosticInfoStrings.Header}</h5>
      </div>
      <DiagnosticTable/>
    </div>
  )
}

export default DiagnosticTab
